<section class="getting-started-section" aria-labelledby="getting-started-heading" id="getting-started">
  <div class="container">
    <p class="section-label text-center">Choose how you want to get started</p>
    <h2 id="getting-started-heading" class="section-title">Getting started with MemberTrace</h2>
    <p class="section-subtitle">
      Whether you're evaluating MemberTrace, launching a new society, or moving an established organization, there's a path designed for where you are today.
    </p>

    <div class="path-grid">
      <article class="path-card" *ngFor="let path of paths" [class.highlighted]="path.highlighted">
        <p *ngIf="path.badge" class="path-badge">{{ path.badge }}</p>
        <p class="path-eyebrow">{{ path.eyebrow }}</p>
        <h3>{{ path.title }}</h3>
        <p *ngIf="path.offerRule" class="path-offer-rule">{{ path.offerRule }}</p>
        <p class="path-description">{{ path.description }}</p>
        <p *ngIf="path.supportingNote" class="path-supporting-note">{{ path.supportingNote }}</p>
        <ul>
          <li *ngFor="let term of path.terms">{{ term }}</li>
        </ul>
        <p *ngIf="path.guardrail && !path.offerRule" class="path-guardrail">{{ path.guardrail }}</p>
        <a mat-flat-button
           color="primary"
           [routerLink]="path.ctaLink"
           [queryParams]="path.queryParams"
           (click)="onPathCta(path)">
          {{ path.ctaLabel }}
        </a>
      </article>
    </div>
  </div>
</section>
